import React from "react";
import Story from "../../layouts/Story";
import SiteMap from "./charts/SiteMap";
import BubbleChart from "./charts/BubbleChart";
import CasesList from "./charts/CasesList";
import RisksDiagram from "./charts/RisksDiagram";
import CycleDiagram from "./charts/CycleDiagram";
import CycleDiagramES from "./charts/CycleDiagram/ES";
import CycleDiagramFR from "./charts/CycleDiagram/FR";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const StoryNine = () => {
  const additionalComponents = {
    siteMap: SiteMap,
    bubbleChart: BubbleChart,
    casesList: CasesList,
    risksDiagram: RisksDiagram,
    cycleDiagram: CycleDiagram,
    cycleDiagramES: CycleDiagramES,
    cycleDiagramFR: CycleDiagramFR,
  };

  return <Story {...copy} additionalComponents={additionalComponents} />;
};

export default StoryNine;
